import Vue from "vue";
import * as jobs from "../../../static/json/jobs.json";
//模块：加入我们
export default Vue.extend({
    name: "join-us",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        jobList: function () {
            return jobs[this.$store.state.um.lang];
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/about/join-us.vue
// module id = null
// module chunks = 